module.exports = __webpack_public_path__ + "new_role.1f5c0d339b413928373455039ca5b528.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu/new_role.svg
// module id = 323
// module chunks = 0